import { useState } from 'react';
import { motion } from 'motion/react';
import BorderImage from '@/assets/images/0-circles-dashes.svg';
import { Div0 } from './Div0';
import { Div1 } from './Div1';
import { Div2 } from './Div2';
import { Div3 } from './Div3';

interface Props {
  onComplete: () => void;
}

export const Step0 = ({ onComplete }: Props) => {
  const [currentDivIndex, setCurrentDivIndex] = useState(0);

  const nextDiv = () => setCurrentDivIndex(prevState => prevState + 1);

  return (
    <div
      className="relative min-h-dvh w-screen bg-grey flex flex-col justify-center items-center p-4 md:p-8 border-image-dashed text-white"
      style={{
        borderImageSource: `url(${BorderImage})`,
      }}
    >
      {currentDivIndex === 0 && <Div0 onComplete={nextDiv} />}
      {currentDivIndex === 1 && <Div1 onComplete={nextDiv} />}
      {currentDivIndex === 2 && <Div2 onComplete={nextDiv} />}
      {currentDivIndex === 3 && <Div3 onComplete={onComplete} />}

      {/* Covers border+content area and fades out — reveals everything without animating border-image directly */}
      <motion.div
        initial={{ opacity: 1 }}
        animate={{ opacity: 0, transition: { duration: 4, ease: 'easeInOut' } }}
        className="absolute -inset-8 md:-inset-12 bg-grey pointer-events-none"
      />
    </div>
  );
};
